import React from 'react';

import { Link } from 'gatsby';

import BlakeSpread from '../../../../images/pdr-vol-7/blake-spread.jpg';
import WattsHughesSpread from '../../../../images/pdr-vol-7/watts-hughes-spread.jpg';
import Cover from '../../../../images/pdr-vol-7/cover.jpg';

import '../../../styles/common/promos/book-launch-banner.scss';

const BookLaunchBanner = (props) => (
  <>
    {(props.path !== '/product/the-public-domain-review-selected-essays-vol-vii/' &&
      props.path !== '/product/the-public-domain-review-selected-essays-vol-vii') ? (
      <div role="complementary" aria-label="Promotional Banner" className="sitewide-banner book-launch-banner">
        <Link to="/product/the-public-domain-review-selected-essays-vol-vii">
          <div className="contents page-width">
            <div className="left-side">
              <div className="images">
                <div><img src={ Cover } alt="Cover of PDR Vol. 7" /></div>
                <div><img src={ WattsHughesSpread } alt="Spread with Margaret Watts Hughes illustration" /></div>
              </div>
            </div>
            <div className="details">
              <span className="headline">
                Our New Essays Book Is Launched!
              </span>
              <span className="subhead">
                Unicorns, wombats, Philip Pullman, and more…
              </span>

              <span className="cta-button">
                Order Today
              </span>

              <span className="footer">
                “Early Bird” 20% Discount Available Now
              </span>
            </div>
            <div className="right-side">
              <div className="images">
                <div><img src={ BlakeSpread } alt="Spread with William Blake illustration" /></div>
                <div><img src={ Cover } alt="Cover of PDR Vol. 7" /></div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    ) : null}
  </>
);

export default BookLaunchBanner;
